// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ca3U","notes":"Notes_notes__1322d"};